import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { getUserProfile } from '../user.service';
import { UserProfile } from '@/services/user/userTypes';

interface UseGetUserProfile {
  userId: string;
  enabled?: boolean;
}

interface useGetProfileResult {
  data: UserProfile;
}

const useGetUserProfile = ({
  userId,
  enabled = true,
}: UseGetUserProfile): UseQueryResult<useGetProfileResult, Error> => {
  return useQuery<useGetProfileResult, Error>({
    queryKey: ['userProfile', userId],
    queryFn: async () => {
      if (!userId) {
        throw new Error('User ID is required');
      }
      const response = await getUserProfile(userId);
      return { data: response.data };
    },
    enabled,
  });
};

export default useGetUserProfile;
